'use client';

import React from 'react';
import { useCompositionDensity } from './composition-density';
import { cn } from '../lib/utils';
import { Settings2 } from 'lucide-react';
import { Button } from './button';
import type { ControlDensity, ControlSize } from './control-styles';

export interface CustomiseButtonProps {
  onClick: () => void;
  className?: string;
  label?: string;
  size?: ControlSize;
  density?: ControlDensity;
}

export function CustomiseButton({
  onClick,
  className,
  label = 'Customise',
  size = 'compact',
  density,
}: CustomiseButtonProps) {
  const resolvedDensity = useCompositionDensity(density);
  return (
    <Button
      type="button"
      variant="outline"
      size={size}
      density={resolvedDensity}
      onClick={onClick}
      className={cn('shrink-0 whitespace-nowrap', className)}
      title="Customise this view"
      aria-label={label === 'Customise' ? 'Customise this view' : label}
    >
      <Settings2 className="h-3.5 w-3.5" />
      {label}
    </Button>
  );
}
